import { render } from "./IInvestedStandardList.vue?vue&type=template&id=30eaed64&scoped=true&ts=true"
import script from "./IInvestedStandardList.vue?vue&type=script&lang=ts"
export * from "./IInvestedStandardList.vue?vue&type=script&lang=ts"

import "./IInvestedStandardList.vue?vue&type=style&index=0&id=30eaed64&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30eaed64"]])

export default __exports__